export { default } from '@shikijs/langs/shellscript'
